export default __webpack_public_path__ + "static/start_4-b4d0e911f2d99e70075655e7353db1b9.png";